<template>
  <v-edit-dialog
      @open="item = value"
  >
    <!--    :return-value.sync="item"-->
    <v-icon>mdi-dots-horizontal</v-icon>
    <template v-slot:input>
<!--      <v-row no-gutters class="flex-nowrap" v-if="!!item && !!item.page_properties" dense>-->
<!--        <v-checkbox-->
<!--            :label="$t('lock_page')"-->
<!--            dense-->
<!--            v-model="item.page_properties.lock_page"-->
<!--            on-icon="mdi-lock-outline"-->
<!--            off-icon="mdi-lock-open-variant-outline"-->
<!--        ></v-checkbox>-->
<!--      </v-row>-->
<!--      <v-row no-gutters class="flex-nowrap" v-if="!!item && !!item.page_properties" dense>-->
<!--        <v-checkbox-->
<!--            :label="$t('show_deleted')"-->
<!--            dense-->
<!--            v-model="item.page_properties.show_deleted"-->
<!--        ></v-checkbox>-->
<!--      </v-row>-->
<!--      <v-row no-gutters class="flex-nowrap" v-if="!!item && !!item.page_properties">-->
<!--        <BaseDeleteIcon-->
<!--            v-model="item.deleted"-->
<!--            :readonly="item.page_properties.lock_page"-->
<!--            :show_label="true"-->
<!--        ></BaseDeleteIcon>-->
<!--      </v-row>-->
      <v-row no-gutters class="flex-nowrap" v-if="!!item && !!item.prototype">
        <BaseConfirmIcon
            :disabled="!isEnabledUpdateFromPrototype()"
            :labels="updateLabels"
            :loading="parent.commandLoading"
            @click="onUpdateFromPrototype()"
        ></BaseConfirmIcon>
      </v-row>
    </template>
  </v-edit-dialog>
</template>

<script>
import commonFunction from '@/commonFunction/commonFunction'
import {v4 as uuidv4} from "uuid";
import draggable from "vuedraggable";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";
import BaseConfirmBtn from "@/components/Base/BaseConfirmBtn";
import BaseConfirmIcon from "@/components/Base/BaseConfirmIcon";

export default {
  name: 'BaseItemProperty',
  props: {
    value: {default: {}},
    parent: {default: {}},
  },

  components: {
    BaseConfirmBtn,
    BaseDeleteIcon,
    BaseConfirmIcon,
  },

  computed: {},

  watch: {
    item: {
      handler(newValue, oldValue) {
        // console.log('watch', newValue, oldValue)
        this.$emit('input', newValue)
      },
      deep: true
    },
  },

  methods: {
    onUpdateFromPrototype() {
      console.log('onUpdateFromPrototype', this.parent.dtoUpdateModeldtoUpdateModel, this.parent.editedItem.uid)
      let dto_action = {
        updated_uid_list: [this.parent.editedItem.uid]
      }
      this.parent.fetchAction({dto_action_model: this.parent.dtoUpdateModel, dto: dto_action})
    },
    isEnabledUpdateFromPrototype() {
      return !!this.parent.editedItem && !!this.parent.editedItem.prototype_uid &&
          this.parent.editedItem.version !== this.parent.editedItem.prototype.version &&
          !this.item.page_properties.lock_page && !this.parent.isDataChange
    }
  },

  mounted() {
  },

  data() {
    return {
      item: null,
      updateLabels: {
        btn: 'Update',
        icon: 'mdi-update',
        confirm: 'OK',
        cancel: 'Cancel',
        text: 'Are you sure?',
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>

<i18n>
{
  "en": {
    "lock_page": "Lock page",
    "show_deleted": "Show deleted"
  },
  "de": {
    "lock_page": "Seite sperren",
    "show_deleted": "Sendung gelöscht"
  }
}

</i18n>

